import withDraft from '@/utils/draftHelper';
import { states } from '@/constants/lifecycle';
import actions from '../catalogue/templates/constants';
import { assignEditProps, showDatasetErrorState } from './state';
import findDataset from './shared';

const showCatalogueTemplateDatasetError = withDraft((draft, action) => {
  showDatasetErrorState(draft, { ...action, code: action.datasetCode });
});

const showCatalogueTemplate = withDraft((draft, { category, datasetCode, result }) => {
  const item = findDataset(draft, { category, code: datasetCode });

  item.readStatus = states.SUCCESS;
  if (item.isNew || item.steps.wizardOn) {
    assignEditProps(item, result, item.isNew);
  }
});

export default {
  [actions.SHOW_CATALOGUE_TEMPLATE_DATASET_SUCCESS]: showCatalogueTemplate,
  [actions.SHOW_CATALOGUE_TEMPLATE_DATASET_ERROR]: showCatalogueTemplateDatasetError,
};
